module.exports = __webpack_public_path__ + "img/img2.1c5c4acf.jpg";